import { NgModule } from '@angular/core';
import { PlanningComponent } from './planning/planning.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { EventEditComponent } from './event-edit/event-edit.component';
import { BuildSolutionComponent } from './build-solution/build-solution.component';
import { CreateVacationComponent } from './create-vacation/create-vacation.component';
import { NavbarPlanningComponent } from './navbar-planning/navbar-planning.component';
import { ListPlanningComponent } from './list-planning/list-planning.component';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { WeekViewAlignedComponent } from './week-view-aligned/week-view-aligned.component';
import { SelectSolutionComponent } from './select-solution/select-solution.component';
import { ListPlanningWeekComponent } from './list-planning-week/list-planning-week.component';

@NgModule({
	declarations: [
		PlanningComponent,
		EventEditComponent,
		BuildSolutionComponent,
		CreateVacationComponent,
		NavbarPlanningComponent,
		ListPlanningComponent,
		WeekViewAlignedComponent,
		SelectSolutionComponent,
		ListPlanningWeekComponent
	],
	imports: [SharedModule, NgxSliderModule, CollapseModule],
	providers: []
})
export class PlanningModule {}
